import script from "./Metadata.vue?vue&type=script&setup=true&lang=ts"
export * from "./Metadata.vue?vue&type=script&setup=true&lang=ts"

import "./Metadata.vue?vue&type=style&index=0&id=ccea9002&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccea9002"]])

export default __exports__